import { render } from "./AdminSidebar.vue?vue&type=template&id=9bf6115e"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrii/Documents/Projects/op-cl-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__